import { Suspense } from "react";
import { useAtomValue, useSetAtom } from "jotai";
import { Button } from "@zapier/design-system-beta";
import {
  isExecutingZslAtom,
  upgradeBannerPropsAsyncAtom,
  canvasNameAtom,
  handleUseTemplateCommand,
  numberOfUniqueTableNodesAtom,
  numberOfUniqueInterfaceNodesAtom,
  numberOfUniqueChatbotNodesAtom,
} from "@zapier/canvas-state";

import { UpgradeBanner } from "../UpgradeBanner";
import { BannerWrapper } from "../BannerWrapper";
import { LoadingTemplateBanner } from "../LoadingTemplateBanner";

/** This banner is being used in the template page
 *  ex: app/canvas/template/lead-capture
 * */

function TemplateExecutionBanner() {
  const isZslExecuting = useAtomValue(isExecutingZslAtom);
  const canvasName = useAtomValue(canvasNameAtom);
  const handleUseTemplate = useSetAtom(handleUseTemplateCommand);

  const title = `You are previewing the template '${canvasName}'`;
  const description =
    "Using this template will create the Zapier assets displayed below.";

  return (
    <BannerWrapper title={title} description={description}>
      <Button isLoading={isZslExecuting} onPress={handleUseTemplate}>
        Use this template
      </Button>
    </BannerWrapper>
  );
}

function SuspendedBanner() {
  const upgradeBannerProps = useAtomValue(upgradeBannerPropsAsyncAtom);

  if (upgradeBannerProps === null) {
    return <TemplateExecutionBanner />;
  }

  return <UpgradeBanner {...upgradeBannerProps} location="Template banner" />;
}

export function TemplatePageBanner() {
  const numberOfTableNodes = useAtomValue(numberOfUniqueTableNodesAtom);
  const numberOfInterfaceNodes = useAtomValue(numberOfUniqueInterfaceNodesAtom);
  const numberOfChatbotNodes = useAtomValue(numberOfUniqueChatbotNodesAtom);
  const shouldShowSuspendedBanner =
    numberOfTableNodes + numberOfInterfaceNodes + numberOfChatbotNodes > 0;

  if (shouldShowSuspendedBanner) {
    return (
      <Suspense fallback={<LoadingTemplateBanner />}>
        <SuspendedBanner />
      </Suspense>
    );
  }

  return <TemplateExecutionBanner />;
}
